import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../authContext';
import { useModal } from '../../contexts/ModalContext/ModalContext';

const SellerRoute = ({ children }) => {
    const { currentUser } = useAuth();
    const { showModal } = useModal();  // Esta función debe mostrar el modal
    const navigate = useNavigate();
    
    const [hasRedirected, setHasRedirected] = useState(false);

    // Permitir acceso si el usuario es "vendedor" o "admin"
    // const hasAccess = currentUser && (currentUser.photoURL === "vendedor" || currentUser.photoURL === "admin");
    const hasAccess = currentUser && (currentUser.photoURL === "vendedor");

    useEffect(() => {
        if (!hasAccess && !hasRedirected) {
            // Muestra el modal una sola vez
            showModal(
                <>
                    <h2>Acceso Restringido</h2>
                    <p>
                        Parece que no tienes permisos para acceder a este sitio aún. 
                        Por favor, contáctanos para más información.
                    </p>
                    <button
                        onClick={() => {
                            window.location.href = "mailto:contacto@empresa.com";
                        }}
                        className="btn btn-primary"
                    >
                        Contáctanos
                    </button>
                </>
            );
            setHasRedirected(true);
            navigate("/", { replace: true });
        }
    }, [hasAccess, showModal, navigate, hasRedirected]);

    return hasAccess ? children : null;
};

export default SellerRoute;
